import React, { useState, useEffect } from "react";
import $ from "jquery";
import "jquery-ui/themes/base/all.css";
import "jquery-ui/ui/widgets/datepicker";
import Select from "react-select";

import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import {
  FiPlus,
  FiTrash2,
  FiFileText,
  FiUser,
  FiPackage,
  FiDollarSign,
  FiSettings,
  FiTag,
  FiInfo,
  FiCheckCircle,
  FiClock,
  FiSave,
  FiAlertCircle,
} from "react-icons/fi";

import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import { FaInfoCircle } from "react-icons/fa";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

  :root {
    --ci-teal:    #0a5556;
    --ci-mid:     #0c7172;
    --ci-lite:    #14b8a6;
    --ci-teal200: #c8e4e4;
    --ci-teal100: #eef6f6;
    --ci-teal50:  #f3fafa;
    --ci-gold:    #FFD166;
    --ci-danger:  #ef4444;
    --ci-warning: #f59e0b;
    --ci-success: #10b981;
    --ci-text:    #062020;
    --ci-muted:   #6b8a8a;
    --ci-border:  rgba(10,85,86,0.13);
    --ci-shadow:  0 2px 12px rgba(10,85,86,0.08);
    --ci-shadow-md: 0 8px 32px rgba(10,85,86,0.10);
    --ci-r-sm: 10px;
    --ci-r-md: 16px;
    --ci-r-lg: 22px;
  }

  @keyframes ci__fadeUp  { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:translateY(0)} }
  @keyframes ci__fadeIn  { from{opacity:0} to{opacity:1} }
  @keyframes ci__pulse   { 0%,100%{box-shadow:0 0 0 0 rgba(10,85,86,0.35)} 70%{box-shadow:0 0 0 7px rgba(10,85,86,0)} }
  @keyframes ci__shimmer { 0%{background-position:-400px 0} 100%{background-position:400px 0} }
  @keyframes ci__modalIn { from{opacity:0;transform:scale(0.94) translateY(10px)} to{opacity:1;transform:scale(1) translateY(0)} }
  @keyframes ci__overlayIn { from{opacity:0} to{opacity:1} }
  @keyframes ci__floatA  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-12px)} }
  @keyframes ci__floatB  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(9px)} }

  /* page shell */
  .ci__page { font-family:'DM Sans',sans-serif; background:var(--ci-teal100); min-height:100vh; position:relative; overflow-x:hidden; }
  .ci__blob { position:fixed; border-radius:50%; pointer-events:none; z-index:0; }
  .ci__blob--1 { width:380px;height:380px;top:-120px;right:-80px; background:radial-gradient(circle,rgba(10,85,86,.12) 0%,transparent 70%); animation:ci__floatA 10s ease-in-out infinite; }
  .ci__blob--2 { width:300px;height:300px;bottom:40px;left:-70px; background:radial-gradient(circle,rgba(20,184,166,.11) 0%,transparent 70%); animation:ci__floatB 12s ease-in-out infinite; }
  .ci__grid { position:fixed;inset:0;pointer-events:none;z-index:0; background-image:linear-gradient(rgba(10,85,86,.03) 1px,transparent 1px),linear-gradient(90deg,rgba(10,85,86,.03) 1px,transparent 1px); background-size:52px 52px; }

  .ci__wrapper { position:relative;z-index:1; padding:22px 22px 60px; animation:ci__fadeIn .5s ease both; }

  /* page header */
  .ci__page-header { display:flex;align-items:center;justify-content:space-between; margin-bottom:22px; animation:ci__fadeUp .5s ease both; }
  .ci__page-header-left { display:flex;align-items:center;gap:13px; }
  .ci__page-header-icon { width:46px;height:46px;border-radius:14px;flex-shrink:0; background:linear-gradient(135deg,var(--ci-teal),var(--ci-lite)); display:flex;align-items:center;justify-content:center; box-shadow:0 6px 20px rgba(10,85,86,.30); color:#fff;font-size:20px; }
  .ci__page-title { font-family:'Sora',sans-serif;font-size:22px;font-weight:800;color:var(--ci-text);letter-spacing:-.04em;margin:0 0 2px;line-height:1; }
  .ci__page-sub { font-size:12px;color:var(--ci-muted);margin:0; }

  /* section label */
  .ci__section-label { display:flex;align-items:center;gap:9px; margin-bottom:12px; }
  .ci__section-icon { width:30px;height:30px;border-radius:9px; background:linear-gradient(135deg,var(--ci-teal),var(--ci-lite)); display:flex;align-items:center;justify-content:center; color:#fff;font-size:13px;flex-shrink:0; box-shadow:0 3px 10px rgba(10,85,86,.25); }
  .ci__section-title { font-family:'Sora',sans-serif;font-size:13.5px;font-weight:700;color:var(--ci-teal);letter-spacing:.01em; }

  /* glass card */
  .ci__card { background:rgba(255,255,255,.92); backdrop-filter:blur(22px); border:1px solid rgba(255,255,255,.88); border-radius:var(--ci-r-lg); box-shadow:0 0 0 1px var(--ci-border),var(--ci-shadow-md); overflow:hidden; position:relative; margin-bottom:18px; }
  .ci__card::before { content:'';position:absolute;top:0;left:0;right:0;height:3px; background:linear-gradient(90deg,var(--ci-teal) 0%,var(--ci-lite) 55%,var(--ci-gold) 100%); }
  .ci__card-body { padding:20px 22px; }
  .ci__card-body--compact { padding:14px 18px; }

  /* form elements */
  .ci__label { display:block;font-size:11px;font-weight:700;color:var(--ci-teal);letter-spacing:.06em;text-transform:uppercase;margin-bottom:6px;font-family:'Sora',sans-serif; }
  .ci__input { width:100%;padding:9px 13px;background:var(--ci-teal50);border:1.5px solid var(--ci-teal200);border-radius:var(--ci-r-sm);font-size:13px;color:var(--ci-text);font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s,box-shadow .2s,background .2s; }
  .ci__input:focus { border-color:var(--ci-teal);background:#fff;box-shadow:0 0 0 3px rgba(10,85,86,.10); }
  .ci__input::placeholder { color:#9ababa; }
  .ci__input:disabled { opacity:.55;cursor:not-allowed;background:rgba(10,85,86,.04); }
  .ci__input--sm { padding:7px 11px;font-size:12.5px; }
  .ci__select { width:100%;padding:9px 13px;background:var(--ci-teal50);border:1.5px solid var(--ci-teal200);border-radius:var(--ci-r-sm);font-size:13px;color:var(--ci-text);font-family:'DM Sans',sans-serif;outline:none;cursor:pointer;transition:border-color .2s,box-shadow .2s; }
  .ci__select:focus { border-color:var(--ci-teal);box-shadow:0 0 0 3px rgba(10,85,86,.10);background:#fff; }
  .ci__textarea { width:100%;padding:9px 13px;background:var(--ci-teal50);border:1.5px solid var(--ci-teal200);border-radius:var(--ci-r-sm);font-size:13px;color:var(--ci-text);font-family:'DM Sans',sans-serif;outline:none;resize:vertical;transition:border-color .2s,box-shadow .2s; }
  .ci__textarea:focus { border-color:var(--ci-teal);background:#fff;box-shadow:0 0 0 3px rgba(10,85,86,.10); }

  .ci__field { margin-bottom:14px; }

  /* toggle buttons */
  .ci__toggle-group { display:flex;border-radius:var(--ci-r-sm);overflow:hidden;border:1.5px solid var(--ci-teal200);background:var(--ci-teal50); }
  .ci__toggle-btn { flex:1;padding:8px 12px;border:none;background:transparent;font-size:12.5px;font-weight:600;font-family:'DM Sans',sans-serif;color:var(--ci-muted);cursor:pointer;transition:all .2s;white-space:nowrap; }
  .ci__toggle-btn:not(:last-child) { border-right:1.5px solid var(--ci-teal200); }
  .ci__toggle-btn--active { background:linear-gradient(135deg,var(--ci-teal),var(--ci-mid));color:#fff;box-shadow:0 3px 10px rgba(10,85,86,.28); }
  .ci__toggle-btn--active-success { background:linear-gradient(135deg,var(--ci-success),#34d399);color:#fff;box-shadow:0 3px 10px rgba(16,185,129,.28); }
  .ci__toggle-btn--active-warning { background:linear-gradient(135deg,var(--ci-warning),#fbbf24);color:#fff;box-shadow:0 3px 10px rgba(245,158,11,.28); }

  /* payment status badge */
  .ci__status-badge { display:inline-flex;align-items:center;gap:6px;padding:4px 12px;border-radius:50px;font-size:11px;font-weight:700;font-family:'Sora',sans-serif; }
  .ci__status-badge--due { background:rgba(245,158,11,.12);color:#b45309;border:1px solid rgba(245,158,11,.25); }
  .ci__status-badge--paid { background:rgba(16,185,129,.12);color:#059669;border:1px solid rgba(16,185,129,.25); }
  .ci__status-badge::before { content:'';width:5px;height:5px;border-radius:50%;background:currentColor; }

  /* divider */
  .ci__divider { height:1px;background:var(--ci-border);margin:18px 0; }

  /* seller/customer columns */
  .ci__billing-grid { display:grid;grid-template-columns:1fr 1fr;gap:0; }
  .ci__billing-col { padding:0 20px 4px; }
  .ci__billing-col:first-child { padding-left:0;border-right:1px solid var(--ci-border); padding-right:22px; }
  .ci__billing-col:last-child { padding-left:22px;padding-right:0; }
  .ci__col-header { display:flex;align-items:center;gap:8px;margin-bottom:14px; }
  .ci__col-header-icon { width:28px;height:28px;border-radius:8px;background:rgba(10,85,86,.09);display:flex;align-items:center;justify-content:center;color:var(--ci-teal);font-size:13px; }
  .ci__col-header-title { font-family:'Sora',sans-serif;font-size:12.5px;font-weight:700;color:var(--ci-teal); }
  .ci__col-header-sub { font-size:10.5px;color:var(--ci-muted); }

  /* items table */
  .ci__table-wrap { overflow-x:auto; }
  .ci__table { width:100%;border-collapse:collapse;font-family:'DM Sans',sans-serif; }
  .ci__table thead tr { background:linear-gradient(135deg,rgba(10,85,86,.055),rgba(20,184,166,.025));border-bottom:1.5px solid var(--ci-teal200); }
  .ci__table thead th { padding:10px 14px;font-family:'Sora',sans-serif;font-size:10px;font-weight:700;color:var(--ci-teal);letter-spacing:.07em;text-transform:uppercase;white-space:nowrap; }
  .ci__table tbody tr { border-bottom:1px solid rgba(10,85,86,.06);transition:background .15s; }
  .ci__table tbody tr:last-child { border-bottom:none; }
  .ci__table tbody tr:hover { background:rgba(10,85,86,.028); }
  .ci__table td { padding:10px 14px;vertical-align:middle; }

  /* item amount display */
  .ci__item-amount { font-family:'Sora',sans-serif;font-weight:700;font-size:13px;color:var(--ci-teal); }

  /* delete row btn */
  .ci__del-btn { width:30px;height:30px;border-radius:8px;border:1.5px solid rgba(239,68,68,.25);background:rgba(239,68,68,.07);color:var(--ci-danger);display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .18s;font-size:14px; }
  .ci__del-btn:hover { background:rgba(239,68,68,.15);border-color:rgba(239,68,68,.45);transform:scale(1.05); }

  /* add item btn */
  .ci__add-btn { display:inline-flex;align-items:center;gap:7px;padding:9px 18px;border-radius:var(--ci-r-sm);border:none;background:linear-gradient(135deg,var(--ci-teal),var(--ci-lite));color:#fff;font-family:'Sora',sans-serif;font-size:12.5px;font-weight:700;cursor:pointer;box-shadow:0 4px 14px rgba(10,85,86,.28);transition:all .2s; }
  .ci__add-btn:hover { transform:translateY(-1px);box-shadow:0 8px 22px rgba(10,85,86,.36); }

  /* summary card */
  .ci__summary-card { background:linear-gradient(135deg,rgba(10,85,86,.05),rgba(20,184,166,.03)); border:1.5px solid var(--ci-teal200); border-radius:var(--ci-r-md); padding:16px; }
  .ci__summary-row { display:flex;align-items:center;justify-content:space-between;padding:7px 0;font-size:13px;color:#2d4a4a;border-bottom:1px solid rgba(10,85,86,.07); }
  .ci__summary-row:last-child { border-bottom:none; }
  .ci__summary-label { font-weight:500; }
  .ci__summary-value { font-family:'Sora',sans-serif;font-weight:700;font-size:13.5px;color:var(--ci-teal); }
  .ci__summary-value--danger { color:var(--ci-danger); }

  /* grand total */
  .ci__grand-total { background:linear-gradient(135deg,var(--ci-teal),var(--ci-mid)); border-radius:var(--ci-r-md); padding:16px 18px; display:flex;align-items:center;justify-content:space-between; margin-top:14px; }
  .ci__grand-label { font-family:'Sora',sans-serif;font-size:14px;font-weight:700;color:rgba(255,255,255,.85); }
  .ci__grand-value { font-family:'Sora',sans-serif;font-size:22px;font-weight:800;color:#fff;letter-spacing:-.03em; }

  /* gst type badge */
  .ci__gst-type { display:inline-flex;align-items:center;gap:5px;padding:3px 10px;border-radius:50px;font-size:10.5px;font-weight:700;font-family:'Sora',sans-serif; background:rgba(10,85,86,.09);color:var(--ci-teal);border:1px solid var(--ci-teal200); }

  /* tax breakdown */
  .ci__tax-row { display:flex;align-items:center;justify-content:space-between;padding:5px 0;font-size:12.5px; }
  .ci__tax-label { color:#3d6060; }
  .ci__tax-value { font-family:'Sora',sans-serif;font-weight:700;color:var(--ci-teal); }

  /* save button */
  .ci__save-btn { width:100%;padding:13px;border:none;border-radius:var(--ci-r-md); background:linear-gradient(135deg,var(--ci-teal) 0%,var(--ci-mid) 50%,var(--ci-lite) 100%);background-size:200% auto; color:#fff;font-family:'Sora',sans-serif;font-size:14px;font-weight:700;cursor:pointer; box-shadow:0 8px 26px rgba(10,85,86,.38);transition:all .3s;display:flex;align-items:center;justify-content:center;gap:9px; }
  .ci__save-btn:hover { background-position:right center;transform:translateY(-2px);box-shadow:0 14px 32px rgba(10,85,86,.44); }
  .ci__save-btn:active { transform:translateY(0); }

  /* invoice number chip */
  .ci__inv-num-chip { display:flex;align-items:center;gap:7px;background:rgba(10,85,86,.08);border:1px solid var(--ci-teal200);border-radius:8px;padding:8px 12px; }
  .ci__inv-num-text { font-family:'Sora',sans-serif;font-size:12px;font-weight:700;color:var(--ci-teal); }
  .ci__inv-num-sub { font-size:10px;color:var(--ci-muted); }

  /* info tooltip */
  .ci__info-icon { color:var(--ci-muted);cursor:pointer;font-size:13px;transition:color .18s; }
  .ci__info-icon:hover { color:var(--ci-teal); }

  /* ── CUSTOMER MODAL ── */
  .ci__overlay { position:fixed;inset:0;z-index:9998;background:rgba(6,32,32,.55);backdrop-filter:blur(6px);display:flex;align-items:center;justify-content:center; animation:ci__overlayIn .2s ease; }
  .ci__modal { background:#fff;border-radius:22px;width:100%;max-width:420px;margin:16px;box-shadow:0 32px 80px rgba(10,85,86,.22);animation:ci__modalIn .28s cubic-bezier(.34,1.56,.64,1);overflow:hidden;position:relative; }
  .ci__modal::before { content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--ci-teal),var(--ci-lite),var(--ci-gold)); }
  .ci__modal-header { padding:20px 22px 14px;display:flex;align-items:center;gap:12px;border-bottom:1px solid rgba(10,85,86,.08); background:linear-gradient(135deg,rgba(10,85,86,.04),rgba(20,184,166,.02)); }
  .ci__modal-header-icon { width:38px;height:38px;border-radius:11px;background:linear-gradient(135deg,var(--ci-teal),var(--ci-lite));display:flex;align-items:center;justify-content:center;color:#fff;font-size:17px;box-shadow:0 4px 14px rgba(10,85,86,.30); }
  .ci__modal-title { font-family:'Sora',sans-serif;font-size:15px;font-weight:800;color:var(--ci-text); }
  .ci__modal-sub   { font-size:11px;color:var(--ci-muted);margin-top:2px; }
  .ci__modal-body  { padding:18px 22px; }
  .ci__modal-info-row { display:flex;align-items:flex-start;justify-content:space-between;padding:9px 0;border-bottom:1px solid rgba(10,85,86,.06);font-size:13px; }
  .ci__modal-info-row:last-child { border-bottom:none; }
  .ci__modal-info-label { font-weight:600;color:#3d6060;min-width:110px; }
  .ci__modal-info-value { color:var(--ci-text);font-weight:500;text-align:right;text-transform:capitalize; }
  .ci__modal-cta { padding:4px 18px 18px;display:flex;gap:10px; }
  .ci__modal-cancel-btn { flex:1;padding:11px;border:1.5px solid var(--ci-teal200);border-radius:12px;background:var(--ci-teal50);color:#2d4a4a;font-family:'Sora',sans-serif;font-size:13px;font-weight:700;cursor:pointer;transition:all .18s; }
  .ci__modal-cancel-btn:hover { border-color:var(--ci-teal);color:var(--ci-teal); }
  .ci__modal-confirm-btn { flex:1;padding:11px;border:none;border-radius:12px;background:linear-gradient(135deg,var(--ci-teal),var(--ci-lite));color:#fff;font-family:'Sora',sans-serif;font-size:13px;font-weight:700;cursor:pointer;box-shadow:0 5px 16px rgba(10,85,86,.32);transition:all .18s; }
  .ci__modal-confirm-btn:hover { transform:translateY(-1px);box-shadow:0 9px 22px rgba(10,85,86,.40); }

  /* hint text */
  .ci__hint { font-size:10.5px;color:var(--ci-muted);margin-top:4px;font-style:italic; }

  /* grid helpers */
  .ci__grid-2 { display:grid;grid-template-columns:1fr 1fr;gap:12px; }
  .ci__grid-3 { display:grid;grid-template-columns:1fr 1fr 1fr;gap:12px; }
  .ci__grid-4 { display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:12px; }

  /* ── PRODUCT LOOKUP TOGGLE ── */
  .ci__product-toggle-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 18px;
    background: linear-gradient(135deg, rgba(10,85,86,.06), rgba(20,184,166,.04));
    border-bottom: 1px solid var(--ci-teal200);
  }
  .ci__product-toggle-left {
    display: flex;
    align-items: center;
    gap: 9px;
  }
  .ci__product-toggle-label {
    font-family: 'Sora', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: var(--ci-teal);
    letter-spacing: .03em;
  }
  .ci__product-toggle-sub {
    font-size: 10.5px;
    color: var(--ci-muted);
    margin-top: 1px;
  }
  /* iOS-style pill switch */
  .ci__pill-switch {
    position: relative;
    width: 40px;
    height: 22px;
    flex-shrink: 0;
  }
  .ci__pill-switch input { opacity:0; width:0; height:0; position:absolute; }
  .ci__pill-slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background: #c8e4e4;
    border-radius: 50px;
    transition: background .25s;
  }
  .ci__pill-slider::before {
    content: '';
    position: absolute;
    height: 16px; width: 16px;
    left: 3px; top: 3px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 1px 4px rgba(0,0,0,.18);
    transition: transform .25s;
  }
  .ci__pill-switch input:checked + .ci__pill-slider { background: linear-gradient(135deg, var(--ci-teal), var(--ci-lite)); }
  .ci__pill-switch input:checked + .ci__pill-slider::before { transform: translateX(18px); }

  /* react-select override to match design system */
  .ci-rs__control {
    background: var(--ci-teal50) !important;
    border: 1.5px solid var(--ci-teal200) !important;
    border-radius: var(--ci-r-sm) !important;
    min-height: 34px !important;
    box-shadow: none !important;
    font-family: 'DM Sans', sans-serif !important;
    font-size: 12.5px !important;
    transition: border-color .2s, box-shadow .2s !important;
  }
  .ci-rs__control--is-focused {
    border-color: var(--ci-teal) !important;
    background: #fff !important;
    box-shadow: 0 0 0 3px rgba(10,85,86,.10) !important;
  }
  .ci-rs__placeholder { color: #9ababa !important; font-size: 12.5px !important; }
  .ci-rs__single-value { color: var(--ci-text) !important; font-size: 12.5px !important; }
  .ci-rs__input-container { color: var(--ci-text) !important; font-size: 12.5px !important; }
  .ci-rs__menu {
    border-radius: 12px !important;
    border: 1.5px solid var(--ci-teal200) !important;
    box-shadow: 0 8px 28px rgba(10,85,86,.14) !important;
    overflow: hidden !important;
    font-family: 'DM Sans', sans-serif !important;
    z-index: 9999 !important;
  }
  .ci-rs__option {
    font-size: 12.5px !important;
    padding: 9px 14px !important;
    cursor: pointer !important;
  }
  .ci-rs__option--is-focused { background: rgba(10,85,86,.07) !important; color: var(--ci-text) !important; }
  .ci-rs__option--is-selected { background: linear-gradient(135deg, var(--ci-teal), var(--ci-lite)) !important; color: #fff !important; }
  .ci-rs__indicator-separator { background-color: var(--ci-teal200) !important; }
  .ci-rs__dropdown-indicator { color: var(--ci-teal) !important; padding: 0 8px !important; }
  .ci-rs__clear-indicator { color: var(--ci-muted) !important; }
  .ci-rs__value-container { padding: 2px 10px !important; }

  /* product badge inside option */
  .ci-opt__badge {
    display: inline-block;
    padding: 1px 7px;
    border-radius: 50px;
    font-size: 9.5px;
    font-weight: 700;
    font-family: 'Sora', sans-serif;
    margin-left: 6px;
    vertical-align: middle;
  }
  .ci-opt__badge--service { background: rgba(20,184,166,.15); color: #0c7172; }
  .ci-opt__badge--product { background: rgba(255,209,102,.22); color: #8a6000; }
  .ci-opt__meta { font-size: 10.5px; color: var(--ci-muted); margin-top: 1px; }
  .ci-opt__row { display: flex; align-items: center; justify-content: space-between; }
  .ci-opt__rate { font-family: 'Sora', sans-serif; font-weight: 700; font-size: 11px; color: var(--ci-teal); }

  @media (max-width:900px) {
    .ci__billing-grid { grid-template-columns:1fr; }
    .ci__billing-col:first-child { border-right:none;border-bottom:1px solid var(--ci-border);padding-right:0;padding-bottom:18px;margin-bottom:18px; }
    .ci__billing-col:last-child { padding-left:0; }
    .ci__grid-3 { grid-template-columns:1fr 1fr; }
    .ci__grid-4 { grid-template-columns:1fr 1fr; }
  }
  @media (max-width:600px) {
    .ci__wrapper { padding:14px 12px 48px; }
    .ci__grid-2 { grid-template-columns:1fr; }
    .ci__grid-4 { grid-template-columns:1fr 1fr; }
  }
`;

const GST_SLABS = [0, 5, 12, 18, 28];

const splitGST = (totalTax, gstType) => {
  if (gstType === "IGST") return { IGST: totalTax, CGST: 0, SGST: 0 };
  return { IGST: 0, CGST: totalTax / 2, SGST: totalTax / 2 };
};

// ── Custom Option renderer for React Select ──
const ProductOption = ({ innerRef, innerProps, data, isSelected }) => (
  <div
    ref={innerRef}
    {...innerProps}
    style={{
      padding: "9px 14px",
      cursor: "pointer",
      background: isSelected
        ? "linear-gradient(135deg, #0a5556, #14b8a6)"
        : "transparent",
      color: isSelected ? "#fff" : "#062020",
    }}
  >
    <div className="ci-opt__row">
      <span style={{ fontWeight: 600, fontSize: 12.5 }}>
        {data.label}
        <span
          className={`ci-opt__badge ${
            data.type === "Service" ? "ci-opt__badge--service" : "ci-opt__badge--product"
          }`}
          style={isSelected ? { background: "rgba(255,255,255,.22)", color: "#fff" } : {}}
        >
          {data.type}
        </span>
      </span>
      <span
        className="ci-opt__rate"
        style={isSelected ? { color: "rgba(255,255,255,.85)" } : {}}
      >
        ₹{data.rate}
      </span>
    </div>
    <div className="ci-opt__meta" style={isSelected ? { color: "rgba(255,255,255,.65)" } : {}}>
      HSN/SAC: {data.hsn || "—"} · GST {data.tax}%
    </div>
  </div>
);

function CreateInvoiceGST() {
  const getDefaultDate = (daysOffset = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);
    return istDate.toISOString().split("T")[0];
  };

  const token = localStorage.getItem("auth_token");

  const [customerLookupLoading, setCustomerLookupLoading] = useState(false);
  const [foundCustomer, setFoundCustomer] = useState(null);
  const [showCustomerModal, setShowCustomerModal] = useState(false);

  // ── Product Catalog State ──
  const [productCatalog, setProductCatalog] = useState([]);   // raw API data
  const [productOptions, setProductOptions] = useState([]);   // react-select options
  const [useProductDropdown, setUseProductDropdown] = useState(false); // toggle

  const [invoice, setInvoice] = useState({
    invoiceNumber: "",
    invoiceDate: getDefaultDate(0),
    dueDate: getDefaultDate(15),
    paymentStatus: "Due",
    customer: { name: "", email: "", phone: "", address: "", gstin: "", state: "" },
    seller:   { name: "", gstin: "", state: "", phone: "" },
    items: [{ description: "", hsn: "", qty: 1, rate: "", tax: 18 }],
    discount: 0,
    additionalCharges: 0,
    gstInclusive: false,
    notes: "Please make the payment within 15 days.",
  });

  // ── Fetch Business Info ──
  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        const res = await axios.get(`${baseurl}getBusinessInfo`, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (res.data.success && res.data.data) {
          const b = res.data.data;
          setInvoice((prev) => ({
            ...prev,
            seller: { name: b.business_name || "", gstin: b.gst || "", state: b.state || "", phone: b.whatsapp_number || "" },
          }));
        }
      } catch (err) { console.error("Error fetching business info:", err); }
    };
    fetchBusinessInfo();
  }, []);

  // ── Fetch Product Catalog ──
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(`${baseurl}getAllProducts`, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (res.data.success && res.data.data) {
          const raw = res.data.data;
          setProductCatalog(raw);
          // Build react-select options
          const options = raw.map((p) => ({
            value: p.id,
            label: p.product_data?.name || `Product #${p.id}`,
            description: p.product_data?.name || "",
            hsn: p.product_data?.hsn_sac || "",
            rate: p.product_data?.rate ?? 0,
            tax: p.product_data?.tax_percent ?? 18,
            type: p.type || "Product",
            unit: p.product_data?.unit || "",
          }));
          setProductOptions(options);
        }
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);

  // ── Customer Phone Lookup ──
  useEffect(() => {
    const phone = invoice.customer.phone?.trim();
    if (!phone || phone.length < 10) return;
    const delayDebounce = setTimeout(async () => {
      try {
        setCustomerLookupLoading(true);
        const res = await axios.get(`${baseurl}getCustomerByPhone/${phone}`, {
          headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        if (res.data.success && res.data.data) { setFoundCustomer(res.data.data); setShowCustomerModal(true); }
      } catch (err) { if (err.response?.status !== 404) console.error("Customer lookup error:", err); }
      finally { setCustomerLookupLoading(false); }
    }, 600);
    return () => clearTimeout(delayDebounce);
  }, [invoice.customer.phone]);

  const applyExistingCustomer = () => {
    if (!foundCustomer) return;
    setInvoice((prev) => ({
      ...prev,
      customer: { ...prev.customer, name: foundCustomer.name || "", email: foundCustomer.email || "", address: foundCustomer.address || "", gstin: foundCustomer.gstin || "", state: foundCustomer.state || "" },
    }));
    setShowCustomerModal(false); setFoundCustomer(null);
  };

  const ignoreExistingCustomer = () => { setShowCustomerModal(false); setFoundCustomer(null); };

  const [applyGSTItemWise, setApplyGSTItemWise] = useState(true);
  const [invoiceGSTPercent, setInvoiceGSTPercent] = useState(18);

  const updateInvoiceMeta = (fieldName, value) => setInvoice((prev) => ({ ...prev, [fieldName]: value }));

  const handlePaymentStatusChange = (status) => {
    setInvoice((prev) => {
      const newState = { ...prev, paymentStatus: status };
      if (prev.paymentStatus === "Paid" && status === "Due") newState.dueDate = getDefaultDate(15);
      return newState;
    });
  };
  const isPaid = invoice.paymentStatus === "Paid";

  useEffect(() => {
    const $invoiceDate = $("#invoiceDateInput");
    const $dueDate = $("#dueDateInput");
    const handleDateSelect = (dateText, inst) => {
      const fieldName = inst.id === "invoiceDateInput" ? "invoiceDate" : "dueDate";
      updateInvoiceMeta(fieldName, dateText);
    };
    $invoiceDate.datepicker({ dateFormat: "yy-mm-dd", onSelect: handleDateSelect, defaultDate: invoice.invoiceDate });
    $dueDate.datepicker({ dateFormat: "yy-mm-dd", onSelect: handleDateSelect, defaultDate: invoice.dueDate });
    return () => { $invoiceDate.datepicker("destroy"); $dueDate.datepicker("destroy"); };
  }, []);

  useEffect(() => {
    $("#invoiceDateInput").datepicker("setDate", invoice.invoiceDate);
    if (!isPaid) $("#dueDateInput").datepicker("setDate", invoice.dueDate);
  }, [invoice.invoiceDate, invoice.dueDate, isPaid]);

  const addItem    = () => setInvoice((prev) => ({ ...prev, items: [...prev.items, { description: "", hsn: "", qty: 1, rate: "", tax: 18 }] }));
  const removeItem = (index) => setInvoice((prev) => ({ ...prev, items: prev.items.filter((_, i) => i !== index) }));
  const updateItem = (index, field, value) => { const items = [...invoice.items]; items[index][field] = value; setInvoice({ ...invoice, items }); };
  const updateCustomer = (field, value) => setInvoice((prev) => ({ ...prev, customer: { ...prev.customer, [field]: value } }));
  const updateSeller   = (field, value) => setInvoice((prev) => ({ ...prev, seller:   { ...prev.seller,   [field]: value } }));

  // ── Handle product selection from dropdown ──
  // When a product is selected from the dropdown, auto-fill description, hsn, rate, tax
  // qty remains editable by user. Other fields stay unchanged.
// ── Handle product selection from dropdown ──
const handleProductSelect = (index, selectedOption) => {
  const items = [...invoice.items];
  if (!selectedOption) {
    items[index] = {
      ...items[index],
      description: "",
      hsn: "",
      rate: "",
      tax: 18,
    };
  } else {
    items[index] = {
      ...items[index],
      description: selectedOption.description,
      hsn: selectedOption.hsn,
      rate: selectedOption.rate,
      tax: selectedOption.tax, // full GST % e.g. 18 — splitGST() halves it for CGST/SGST
    };
  }
  setInvoice({ ...invoice, items });
};

  const { items, discount, additionalCharges, gstInclusive, customer, seller } = invoice;
  const itemSubtotal   = items.reduce((acc, item) => acc + item.qty * item.rate, 0);
  const discountAmount = (itemSubtotal * discount) / 100;
  const taxableAmount  = itemSubtotal - discountAmount + Number(additionalCharges);

const calculateTotalTax = () => {
  if (applyGSTItemWise) {
    return items.reduce((acc, item) => {
      const itemAmount = (Number(item.qty) || 0) * (Number(item.rate) || 0);
      const taxRate = Number(item.tax) || 0;
      // item.tax stores full GST % (e.g. 18) — splitGST() handles CGST/SGST halving
      return gstInclusive
        ? acc + (itemAmount * taxRate) / (100 + taxRate)
        : acc + (itemAmount * taxRate) / 100;
    }, 0);
  } else {
    return gstInclusive
      ? (taxableAmount * invoiceGSTPercent) / (100 + invoiceGSTPercent)
      : (taxableAmount * invoiceGSTPercent) / 100;
  }
};

  const totalTax  = calculateTotalTax();
  // const isInterState = (customer.state?.trim()?.toLowerCase() || "") !== (seller.state?.trim()?.toLowerCase() || "");
  
  
  const isInterState =
  !!(customer.state?.trim()) &&
  !!(seller.state?.trim()) &&
  customer.state.trim().toLowerCase() !== seller.state.trim().toLowerCase();
  
  
  const gstType   = isInterState ? "IGST" : "CGST_SGST";
  const { IGST, CGST, SGST } = splitGST(totalTax, gstType);
  const grandTotal = gstInclusive ? taxableAmount : taxableAmount + totalTax;

  const getItemAmountDisplay = (item, isItemWise) => {
    const taxRate = isItemWise ? item.tax : invoiceGSTPercent;
    const grossAmount = item.qty * item.rate;
    if (gstInclusive) return grossAmount.toFixed(2);
    return (grossAmount + (grossAmount * taxRate) / 100).toFixed(2);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) { Swal.fire("Unauthorized", "Please login again", "error"); return; }
    const dataToSend = { ...invoice, discount: Number(invoice.discount), additionalCharges: Number(invoice.additionalCharges), itemSubtotal, taxableAmount, totalTax, grandTotal, gstBreakdown: { IGST, CGST, SGST, gstType, isInterState } };
    console.log("Data to send to backend:", dataToSend);
    try {
      const res = await axios.post(`${baseurl}saveGstInvoice`, dataToSend, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });
      if (res.data.success) {
        Swal.fire({ toast: true, position: "top-end", icon: "success", title: "Invoice saved successfully", showConfirmButton: false, timer: 2500 });
        setTimeout(() => { window.location.href = "/invoices"; }, 1200);
      }
    } catch (error) {
      console.error("Save GST Invoice Error:", error.response?.data || error.message);
      Swal.fire("Error", error.response?.data?.message || "Failed to save invoice", "error");
    }
  };

  const formatCurrency = (n) =>
    Number(n).toLocaleString("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 2 });

  // Find which product option is currently selected for a row (match by description+rate)
  const getSelectedProductOption = (item) => {
    if (!item.description) return null;
    return productOptions.find(
      (o) => o.description === item.description && o.rate === item.rate
    ) || null;
  };

  return (
    <>
      <style>{CSS}</style>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="ci__page">
          <div className="ci__blob ci__blob--1" />
          <div className="ci__blob ci__blob--2" />
          <div className="ci__grid" />

          <div className="ci__wrapper">
            <form onSubmit={handleSubmit}>

              {/* Page Header */}
              <div className="ci__page-header">
                <div className="ci__page-header-left">
                  <div className="ci__page-header-icon"><FiFileText /></div>
                  <div>
                    <h2 className="ci__page-title">Create GST Invoice</h2>
                    <p className="ci__page-sub">Fill in the details below to generate a new GST invoice</p>
                  </div>
                </div>
              </div>

              {/* ── SECTION 1: Invoice Details ── */}
              <div className="ci__section-label">
                <div className="ci__section-icon"><FiFileText size={13} /></div>
                <span className="ci__section-title">Invoice Details</span>
              </div>

              <div className="ci__card">
                <div className="ci__card-body">
                  <div className="ci__grid-4" style={{ alignItems: "end" }}>

                    {/* Invoice Number */}
                    <div>
                      <label className="ci__label">Invoice Number</label>
                      <div className="ci__inv-num-chip">
                        <FiTag size={13} style={{ color: "var(--ci-teal)", flexShrink: 0 }} />
                        <div>
                          <div className="ci__inv-num-text">{invoice.invoiceNumber || "Auto Generated"}</div>
                          <div className="ci__inv-num-sub">System assigned</div>
                        </div>
                      </div>
                    </div>

                    {/* Invoice Date */}
                    <div>
                      <label className="ci__label">Invoice Date</label>
                      <input id="invoiceDateInput" type="text" className="ci__input" value={invoice.invoiceDate}
                        onChange={(e) => updateInvoiceMeta("invoiceDate", e.target.value)} />
                    </div>

                    {/* Payment Status */}
                    <div>
                      <label className="ci__label">Payment Status</label>
                      <div className="ci__toggle-group">
                        <button type="button"
                          className={`ci__toggle-btn ${!isPaid ? "ci__toggle-btn--active-warning" : ""}`}
                          onClick={() => handlePaymentStatusChange("Due")}>
                          <FiClock size={12} style={{ marginRight: 4, verticalAlign: "middle" }} /> Due
                        </button>
                        <button type="button"
                          className={`ci__toggle-btn ${isPaid ? "ci__toggle-btn--active-success" : ""}`}
                          onClick={() => handlePaymentStatusChange("Paid")}>
                          <FiCheckCircle size={12} style={{ marginRight: 4, verticalAlign: "middle" }} /> Paid
                        </button>
                      </div>
                    </div>

                    {/* Due Date */}
                    <div>
                      <label className="ci__label">Due Date</label>
                      <input id="dueDateInput" type="text"
                        className={`ci__input ${isPaid ? "ci__input--paid" : ""}`}
                        value={isPaid ? "N/A — Paid" : invoice.dueDate}
                        onChange={(e) => updateInvoiceMeta("dueDate", e.target.value)}
                        disabled={isPaid}
                        style={isPaid ? { color: "var(--ci-success)", fontWeight: 700 } : {}}
                      />
                    </div>
                  </div>

                  <div className="ci__divider" />

                  {/* GST Settings */}
                  <div className="ci__section-label" style={{ marginBottom: 12 }}>
                    <div className="ci__section-icon" style={{ width: 24, height: 24, borderRadius: 7, fontSize: 11 }}><FiSettings size={11} /></div>
                    <span className="ci__section-title" style={{ fontSize: 12 }}>GST &amp; Tax Settings</span>
                  </div>

                  <div className="ci__grid-3">
                    <div>
                      <label className="ci__label">GST Mode</label>
                      <div className="ci__toggle-group">
                        <button type="button" className={`ci__toggle-btn ${!invoice.gstInclusive ? "ci__toggle-btn--active" : ""}`}
                          onClick={() => setInvoice({ ...invoice, gstInclusive: false })}>Exclusive</button>
                        <button type="button" className={`ci__toggle-btn ${invoice.gstInclusive ? "ci__toggle-btn--active" : ""}`}
                          onClick={() => setInvoice({ ...invoice, gstInclusive: true })}>Inclusive</button>
                      </div>
                    </div>

                    <div>
                      <label className="ci__label">Apply Tax By</label>
                      <div className="ci__toggle-group">
                        <button type="button" className={`ci__toggle-btn ${applyGSTItemWise ? "ci__toggle-btn--active" : ""}`}
                          onClick={() => setApplyGSTItemWise(true)}>Item-wise</button>
                        <button type="button" className={`ci__toggle-btn ${!applyGSTItemWise ? "ci__toggle-btn--active" : ""}`}
                          onClick={() => setApplyGSTItemWise(false)}>Invoice-wise</button>
                      </div>
                    </div>

                    {!applyGSTItemWise && (
                      <div>
                        <label className="ci__label">Invoice GST %</label>
                        <select className="ci__select" value={invoiceGSTPercent}
                          onChange={(e) => setInvoiceGSTPercent(parseFloat(e.target.value))}>
                          {GST_SLABS.map((g) => <option key={g} value={g}>{g}%</option>)}
                        </select>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* ── SECTION 2: Billing Details ── */}
              <div className="ci__section-label">
                <div className="ci__section-icon"><FiUser size={13} /></div>
                <span className="ci__section-title">Billing Details</span>
              </div>

              <div className="ci__card">
                <div className="ci__card-body">
                  <div className="ci__billing-grid">

                    {/* Seller */}
                    <div className="ci__billing-col">
                      <div className="ci__col-header">
                        <div className="ci__col-header-icon"><FiUser size={13} /></div>
                        <div>
                          <div className="ci__col-header-title">Seller Details</div>
                          <div className="ci__col-header-sub">Service / Goods Provider</div>
                        </div>
                      </div>
                      <div className="ci__field">
                        <label className="ci__label">Business Name</label>
                        <input type="text" className="ci__input" value={invoice.seller.name} onChange={(e) => updateSeller("name", e.target.value)} />
                      </div>
                      <div className="ci__field">
                        <label className="ci__label">Phone Number</label>
                        <input type="text" className="ci__input" value={invoice.seller.phone} onChange={(e) => updateSeller("phone", e.target.value)} />
                      </div>
                      <div className="ci__grid-2">
                        <div className="ci__field">
                          <label className="ci__label">GSTIN <span style={{ fontWeight: 400, textTransform: "none", fontSize: 10 }}>(Optional)</span></label>
                          <input type="text" className="ci__input" value={invoice.seller.gstin} onChange={(e) => updateSeller("gstin", e.target.value)} />
                        </div>
                        <div className="ci__field">
                          <label className="ci__label">State</label>
                          <input type="text" className="ci__input" value={invoice.seller.state} onChange={(e) => updateSeller("state", e.target.value)} />
                        </div>
                      </div>
                    </div>

                    {/* Customer */}
                    <div className="ci__billing-col">
                      <div className="ci__col-header">
                        <div className="ci__col-header-icon"><FiUser size={13} /></div>
                        <div>
                          <div className="ci__col-header-title">Customer Details</div>
                          <div className="ci__col-header-sub">Bill To</div>
                        </div>
                      </div>
                      <div className="ci__field">
                        <label className="ci__label">Customer Name</label>
                        <input type="text" className="ci__input" placeholder="Full name" value={customer.name} onChange={(e) => updateCustomer("name", e.target.value)} required />
                      </div>
                      <div className="ci__field">
                        <label className="ci__label" style={{ display: "flex", alignItems: "center", gap: 5 }}>
                          Phone Number
                          <FaInfoCircle className="ci__info-icon" title="Enter phone to auto-fetch saved customer details" />
                          {customerLookupLoading && <span style={{ fontSize: 10, color: "var(--ci-teal)", fontStyle: "italic", fontWeight: 400, textTransform: "none" }}>Searching…</span>}
                        </label>
                        <input type="text" className="ci__input" placeholder="10-digit mobile number" value={customer.phone} onChange={(e) => updateCustomer("phone", e.target.value)} required />
                      </div>
                      <div className="ci__grid-2">
                        <div className="ci__field">
                          <label className="ci__label">GSTIN <span style={{ fontWeight: 400, textTransform: "none", fontSize: 10 }}>(Optional)</span></label>
                          <input type="text" className="ci__input" placeholder="GSTIN" value={customer.gstin} onChange={(e) => updateCustomer("gstin", e.target.value)} />
                        </div>
                        <div className="ci__field">
                          <label className="ci__label">State</label>
                          <input type="text" className="ci__input" placeholder="State" value={customer.state} onChange={(e) => updateCustomer("state", e.target.value)} />
                        </div>
                      </div>
                      <div className="ci__field">
                        <label className="ci__label">Address</label>
                        <textarea className="ci__textarea" rows="2" placeholder="Full address" value={customer.address} onChange={(e) => updateCustomer("address", e.target.value)} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── SECTION 3: Invoice Items ── */}
              <div className="ci__section-label">
                <div className="ci__section-icon"><FiPackage size={13} /></div>
                <span className="ci__section-title">Invoice Items</span>
              </div>

              <div className="ci__card">

                {/* ── Product/Service Dropdown Toggle Bar ── */}
                <div className="ci__product-toggle-bar">
                  <div className="ci__product-toggle-left">
                    <FiPackage size={14} style={{ color: "var(--ci-teal)" }} />
                    <div>
                      <div className="ci__product-toggle-label">
                        Select from Product / Service Catalog
                      </div>
                      <div className="ci__product-toggle-sub">
                        {useProductDropdown
                          ? `${productOptions.length} items available — search by name`
                          : "Enable to pick items from your saved catalog"}
                      </div>
                    </div>
                  </div>
                  <label className="ci__pill-switch">
                    <input
                      type="checkbox"
                      checked={useProductDropdown}
                      onChange={(e) => setUseProductDropdown(e.target.checked)}
                    />
                    <span className="ci__pill-slider" />
                  </label>
                </div>

                <div className="ci__table-wrap">
                  <table className="ci__table">
                    <thead>
                      <tr>
                        {useProductDropdown && <th style={{ width: "20%" }}>Product / Service</th>}
                        <th style={{ width: useProductDropdown ? "20%" : "34%" }}>Description</th>
                        <th style={{ width: "10%" }}>HSN/SAC</th>
                        <th style={{ width: "8%" }}>Qty</th>
                        <th style={{ width: "13%" }}>Rate ({gstInclusive ? "Inc. GST" : "Excl. GST"})</th>
                        {applyGSTItemWise && <th style={{ width: "10%" }}>Tax %</th>}
                        <th style={{ width: "13%" }}>Amount</th>
                        <th style={{ width: "6%", textAlign: "center" }}>Del</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={index}>

                          {/* ── Product Dropdown column (only when toggle is ON) ── */}
                          {useProductDropdown && (
                            <td style={{ minWidth: 180 }}>
                              <Select
                                classNamePrefix="ci-rs"
                                options={productOptions}
                                value={getSelectedProductOption(item)}
                                onChange={(opt) => handleProductSelect(index, opt)}
                                placeholder="Search…"
                                isClearable
                                components={{ Option: ProductOption }}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  control: (base) => ({ ...base, minHeight: 34 }),
                                }}
                              />
                            </td>
                          )}

                          <td>
                            <input
                              type="text"
                              className="ci__input ci__input--sm"
                              value={item.description}
                              onChange={(e) => updateItem(index, "description", e.target.value)}
                              placeholder="Item description"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="ci__input ci__input--sm"
                              value={item.hsn}
                              onChange={(e) => updateItem(index, "hsn", e.target.value)}
                              placeholder="HSN"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="ci__input ci__input--sm"
                              value={item.qty}
                              onChange={(e) => updateItem(index, "qty", parseFloat(e.target.value) || 0)}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className="ci__input ci__input--sm"
                              value={item.rate}
                              onChange={(e) => updateItem(index, "rate", parseFloat(e.target.value) || 0)}
                            />
                          </td>
                          {applyGSTItemWise && (
                            <td>
                              <select
                                className="ci__select"
                                style={{ padding: "7px 11px", fontSize: "12.5px" }}
                                value={item.tax}
                                onChange={(e) => updateItem(index, "tax", parseFloat(e.target.value))}
                              >
                                {GST_SLABS.map((g) => <option key={g} value={g}>{g}%</option>)}
                              </select>
                            </td>
                          )}
                          <td>
                            <span className="ci__item-amount">₹{getItemAmountDisplay(item, applyGSTItemWise)}</span>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <button type="button" className="ci__del-btn" onClick={() => removeItem(index)}>
                              <FiTrash2 size={13} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div style={{ padding: "14px 18px" }}>
                  <button type="button" className="ci__add-btn" onClick={addItem}><FiPlus size={14} /> Add Item</button>
                </div>
              </div>

              {/* ── SECTION 4: Summary & Actions ── */}
              <div className="ci__section-label">
                <div className="ci__section-icon"><FiDollarSign size={13} /></div>
                <span className="ci__section-title">Invoice Summary</span>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: 18, alignItems: "start" }}>

                {/* Left: Discount, Charges, Notes */}
                <div className="ci__card">
                  <div className="ci__card-body">
                    <div className="ci__grid-2">
                      <div className="ci__field">
                        <label className="ci__label">Discount (%)</label>
                        <input type="number" className="ci__input" value={discount}
                          onChange={(e) => setInvoice({ ...invoice, discount: parseFloat(e.target.value) || 0 })}
                          min="0" max="100" />
                        {discountAmount > 0 && (
                          <div className="ci__hint" style={{ color: "var(--ci-danger)" }}>
                            — {formatCurrency(discountAmount)} off
                          </div>
                        )}
                      </div>
                      <div className="ci__field">
                        <label className="ci__label">Additional Charges (₹)</label>
                        <input type="number" className="ci__input" value={additionalCharges}
                          onChange={(e) => setInvoice({ ...invoice, additionalCharges: parseFloat(e.target.value) || 0 })}
                          min="0" />
                      </div>
                    </div>
                    <div className="ci__field" style={{ marginBottom: 0 }}>
                      <label className="ci__label">Notes / Terms &amp; Conditions</label>
                      <textarea className="ci__textarea" rows="3" value={invoice.notes}
                        onChange={(e) => setInvoice({ ...invoice, notes: e.target.value })} />
                    </div>
                  </div>
                </div>

                {/* Right: Tax breakdown + Grand Total + Save */}
                <div>
                  <div className="ci__card" style={{ marginBottom: 12 }}>
                    <div className="ci__card-body">
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                        <span style={{ fontFamily: "'Sora',sans-serif", fontSize: 12, fontWeight: 700, color: "var(--ci-teal)", textTransform: "uppercase", letterSpacing: ".06em" }}>Summary</span>
                        <span className="ci__gst-type">{gstType === "IGST" ? "Inter-State · IGST" : "Intra-State · CGST+SGST"}</span>
                      </div>

                      <div className="ci__summary-card">
                        <div className="ci__summary-row">
                          <span className="ci__summary-label">Subtotal</span>
                          <span className="ci__summary-value">{formatCurrency(itemSubtotal)}</span>
                        </div>
                        {discountAmount > 0 && (
                          <div className="ci__summary-row">
                            <span className="ci__summary-label">Discount ({discount}%)</span>
                            <span className="ci__summary-value ci__summary-value--danger">− {formatCurrency(discountAmount)}</span>
                          </div>
                        )}
                        {Number(additionalCharges) > 0 && (
                          <div className="ci__summary-row">
                            <span className="ci__summary-label">Additional Charges</span>
                            <span className="ci__summary-value">+ {formatCurrency(additionalCharges)}</span>
                          </div>
                        )}
                        <div className="ci__summary-row">
                          <span className="ci__summary-label">Taxable Base</span>
                          <span className="ci__summary-value">{formatCurrency(taxableAmount)}</span>
                        </div>
                      </div>

                      <div style={{ marginTop: 12, marginBottom: 4 }}>
                        <span style={{ fontFamily: "'Sora',sans-serif", fontSize: 11, fontWeight: 700, color: "var(--ci-muted)", textTransform: "uppercase", letterSpacing: ".06em" }}>Tax Breakdown</span>
                      </div>
                      {gstType === "IGST" ? (
                        <div className="ci__tax-row">
                          <span className="ci__tax-label">IGST ({applyGSTItemWise ? "Variable" : `${invoiceGSTPercent}%`})</span>
                          <span className="ci__tax-value">{formatCurrency(IGST)}</span>
                        </div>
                      ) : (
                        <>
                          <div className="ci__tax-row">
                            <span className="ci__tax-label">CGST ({applyGSTItemWise ? "Variable" : `${invoiceGSTPercent / 2}%`})</span>
                            <span className="ci__tax-value">{formatCurrency(CGST)}</span>
                          </div>
                          <div className="ci__tax-row">
                            <span className="ci__tax-label">SGST ({applyGSTItemWise ? "Variable" : `${invoiceGSTPercent / 2}%`})</span>
                            <span className="ci__tax-value">{formatCurrency(SGST)}</span>
                          </div>
                        </>
                      )}
                      <div className="ci__tax-row" style={{ borderTop: "1.5px solid var(--ci-teal200)", marginTop: 6, paddingTop: 8 }}>
                        <span className="ci__tax-label" style={{ fontWeight: 700 }}>Total Tax</span>
                        <span className="ci__tax-value">{formatCurrency(totalTax)}</span>
                      </div>

                      <div className="ci__grand-total">
                        <span className="ci__grand-label">Grand Total</span>
                        <span className="ci__grand-value">{formatCurrency(grandTotal)}</span>
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="ci__save-btn">
                    <FiSave size={16} /> Save Invoice
                  </button>
                </div>
              </div>

              <div style={{ height: 32 }} />
            </form>
          </div>
        </div>
      </main>

      {/* ── Customer Found Modal ── */}
      {showCustomerModal && (
        <div className="ci__overlay" onClick={(e) => e.target === e.currentTarget && ignoreExistingCustomer()}>
          <div className="ci__modal">
            <div className="ci__modal-header">
              <div className="ci__modal-header-icon"><FiUser /></div>
              <div>
                <div className="ci__modal-title">Existing Customer Found</div>
                <div className="ci__modal-sub">A saved customer matches this phone number</div>
              </div>
            </div>
            <div className="ci__modal-body">
              {[
                ["Customer Name", foundCustomer?.name],
                ["Phone Number", foundCustomer?.phone],
                ["Address", foundCustomer?.address],
                ["State", foundCustomer?.state],
                ["GSTIN", foundCustomer?.gstin || "—"],
              ].map(([label, value]) => (
                <div className="ci__modal-info-row" key={label}>
                  <span className="ci__modal-info-label">{label}</span>
                  <span className="ci__modal-info-value">{value}</span>
                </div>
              ))}
            </div>
            <div className="ci__modal-cta">
              <button className="ci__modal-cancel-btn"  onClick={ignoreExistingCustomer}>Enter Manually</button>
              <button className="ci__modal-confirm-btn" onClick={applyExistingCustomer}>Use This Customer</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CreateInvoiceGST;
